import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [성능/운영>요약] Database 성능위젯 정보 조회
   * @author kimjy
   * @param  {Object} params objId, 조회할 rsc정보 등
   * @return {Map}        해당 위젯에 표현될 성능정보
   */
  getDatabaseSummaryRscRsltList(params) {
    return axios.post(`${baseUrl}/performance/summary/database/get-${params.summaryWidgetKey.toLowerCase()}-rsc-rslt-list.do`, params);
  },
  /**
   * [성능/운영>요약] Database 성능위젯 정보 조회 (후면)
   * @author kimjy
   * @param  {Object} params objId, 조회할 rsc정보 등
   * @return {Map}        해당 위젯에 표현될 성능정보
   */
  getDatabaseSummaryRscRsltBackList(params) {
    return axios.post(`${baseUrl}/performance/summary/database/get-${params.summaryWidgetKey.toLowerCase()}-rsc-rslt-back-list.do`, params);
  },

  /**
   * [성능/운영>요약] 데이터베이스 구성정보 위젯 정보 조회
   * @author jeee12
   * @param  {Object} params objId
   * @return {Object}        해당 위젯에 표현될 구성정보
   */
  getDatabaseConfigurationInfo(params) {
    return axios.get(`${baseUrl}/performance/summary/database/get-configuration-info.do`, { params });
  },
  /**
   * [executeDatabaseDeviceInfoUpdate 슬라이딩 팝업 > 장비 정보 업데이트]
   * @author {Yang}
   * @param  {[Integer]} params [objId]
   * @return {[type]}        [description]
   */
  executeDatabaseDeviceInfoUpdate(params) {
    return axios.post(`${baseUrl}/performance/execute-database-update-device-info.do`, params);
  },
  /**
   * [getDatabaseQueryInfo 슬라이딩 팝업 > 쿼리수행기 > 저장 쿼리문 리스트 출력]
   * @author {Yang}
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getDatabaseQueryInfo(params) {
    return axios.post(`${baseUrl}/performance/get-database-query-info.do`, params);
  },
  /**
   * [executeDatabaseUserQuery 슬라이딩 팝업 > 쿼리수행기 > 쿼리 수행 및 수행결과 출력]
   * @author {Yang}
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  executeDatabaseUserQuery(params) {
    return axios.post(`${baseUrl}/performance/execute-database-user-query.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/performance/database/database-info.js